import {
  CLEAR_BUS_LOCATIONS,
  CREATE_BUS,
  CREATE_BUS_SUCCESS,
  GET_BUS_LIST_ERROR,
  GET_BUS_LIST_SUCCESS,
  GET_BUS_LOCATIONS,
  GET_BUS_LOCATIONS_SUCCESS,
  GET_BUSES_BY_CARRIER_ID,
  GET_BUSES_BY_CARRIER_ID_SUCCESS,
  GET_CARRIER_BUS_LIST,
  REMOVE_BUS,
  REMOVE_BUS_SUCCESS,
  SET_BUS_LIST_LOADING,
  SET_BUSES_BY_CARRIER_ID_LOADING,
  UPDATE_BUS,
  UPDATE_BUS_SUCCESS,
  UPDATE_BUS_FAILURE,
  GET_AGENDA_BUS_LOCATION,
  GET_AGENDA_BUS_LOCATION_SUCCESS,
} from '../constants/ActionTypes';

export const clearBusLocations = () => ({
  type: CLEAR_BUS_LOCATIONS,
});

export const createBus = (carrierId, bus) => ({
  type: CREATE_BUS,
  payload: { carrierId, bus },
});

export const createBusSuccess = bus => ({
  type: CREATE_BUS_SUCCESS,
  payload: { bus },
});

export const getBusesByCarrierId = carrierId => ({
  type: GET_BUSES_BY_CARRIER_ID,
  payload: { carrierId },
});

export const getBusesByCarrierIdSuccess = (carrierId, buses) => ({
  type: GET_BUSES_BY_CARRIER_ID_SUCCESS,
  payload: { carrierId, buses },
});

export const getBusListError = () => ({
  type: GET_BUS_LIST_ERROR,
});

export const getBusListSuccess = payload => ({
  type: GET_BUS_LIST_SUCCESS,
  payload,
});

export const getBusLocations = busesIds => ({
  type: GET_BUS_LOCATIONS,
  payload: { busesIds },
});

export const getAgendaBusLocation = busId => ({
  type: GET_AGENDA_BUS_LOCATION,
  payload: { busId },
});

export const getAgendaBusLocationSuccess = location => ({
  type: GET_AGENDA_BUS_LOCATION_SUCCESS,
  payload: { location },
});

export const getBusLocationsSuccess = busLocations => ({
  type: GET_BUS_LOCATIONS_SUCCESS,
  payload: { busLocations },
});

export const getCarrierBusList = carrierId => ({
  type: GET_CARRIER_BUS_LIST,
  payload: { carrierId },
});

export const removeBus = busId => ({
  type: REMOVE_BUS,
  payload: { busId },
});

export const removeBusSuccess = busId => ({
  type: REMOVE_BUS_SUCCESS,
  payload: { busId },
});

export const setBusListLoading = (isLoading = false) => ({
  type: SET_BUS_LIST_LOADING,
  payload: { isLoading },
});

export const setBusesByCarrierIdLoading = (carrierId, loading) => ({
  type: SET_BUSES_BY_CARRIER_ID_LOADING,
  payload: { carrierId, loading },
});

export const updateBus = (carrierId, busId, bus) => ({
  type: UPDATE_BUS,
  payload: { carrierId, busId, bus },
});

export const updateBusSuccess = bus => ({
  type: UPDATE_BUS_SUCCESS,
  payload: { bus },
});

export const updateBusFailure = () => ({
  type: UPDATE_BUS_FAILURE,
});
